(function () {
  document.querySelectorAll('[id^="bas-"]').forEach(function (section) {
    var checkboxes = section.querySelectorAll('[data-bas-item]');
    var totalEl = section.querySelector('[data-bas-total]');
    var listEl = section.querySelector('[data-bas-summary-list]');
    var symbol = section.dataset.currencySymbol || '$';
    var addBtn = section.querySelector('[data-bas-add-bundle]');

    function money(cents) {
      return symbol + (cents / 100).toFixed(2);
    }

    function update() {
      var total = 0;
      var items = [];
      checkboxes.forEach(function (cb) {
        cb.closest('.bas__item').classList.toggle('is-selected', cb.checked);
        if (cb.checked) {
          total += parseInt(cb.dataset.price, 10);
          items.push(cb.dataset.title);
        }
      });
      if (totalEl) totalEl.textContent = money(total);
      if (listEl) listEl.innerHTML = items.map(function (t) { return '<li>' + t + '</li>'; }).join('');
    }

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', update);
    });
    update();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var itemsPayload = [];
        checkboxes.forEach(function (cb) {
          if (cb.checked) itemsPayload.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
        });
        if (!itemsPayload.length) return;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.dispatchEvent(new Event('cart:refresh'));
            addBtn.disabled = false;
            addBtn.textContent = 'Add Bundle to Cart';
            var cartToggle = document.querySelector('[data-cart-toggle]');
            if (cartToggle) {
              cartToggle.click();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Add Bundle to Cart';
            window.location.href = '/cart';
          });
      });
    }
  });
})();